'use strict';

var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["scheduleEntry", "waypoints", "$uibModalInstance", "TimeZoneFactory", function TrainScheduleEntryDetailsController(scheduleEntry, waypoints, $uibModalInstance, TimeZoneFactory) {
    var vm = this;
    vm.scheduleEntry = angular.copy(scheduleEntry);

    var period = TimeZoneFactory.composeCustomPeriod(vm.scheduleEntry.timestamp, {
        start: vm.scheduleEntry.timeTableEntry.start,
        end: vm.scheduleEntry.timeTableEntry.end
    });

    vm.scheduleEntry.start = period.start;
    vm.scheduleEntry.end = period.end;
    vm.scheduleEntry.startStation = vm.scheduleEntry.timeTableEntry.startStation;
    vm.scheduleEntry.endStation = vm.scheduleEntry.timeTableEntry.endStation;
    vm.scheduleEntry.startStation = arrayUtil.getFirstInList(waypoints, 'id', vm.scheduleEntry.timeTableEntry.startStation);
    vm.scheduleEntry.endStation = arrayUtil.getFirstInList(waypoints, 'id', vm.scheduleEntry.timeTableEntry.endStation);
    vm.scheduleEntry.serviceId = vm.scheduleEntry.timeTableEntry.serviceId;
    vm.waypoints = waypoints;

    init();

    /*
     FUNCTIONS
     */

    function init() {

    }

    vm.delete = function () {
        var object = {
            action: 'delete',
            data: vm.scheduleEntry
        };

        $uibModalInstance.close(object);
    };

    vm.save = function () {

        var object = {
            action: 'save',
            data: vm.scheduleEntry
        };

        $uibModalInstance.close(object);
    }

}];
